export type FieldValidationState<T> = {
    validating: boolean;
    validated: boolean;
    error: string | undefined;
    refData?: T;
};

export const setInitialState = () => {
    return {
        validating: false,
        validated: false,
        error: undefined
    };
};

export type FieldValidationAction<T> =
    { type: 'FIELD_CHANGED' } |
    { type: 'VALIDATING_FIELD' } |
    {
        type: 'SERVER_SUCCESS';
        payload?: { fieldDetails: T };
    } |
    {
        type: 'SERVER_ERROR';
        payload: { error: string };
    };

export const fieldValidationReducer = <T>(
    state: FieldValidationState<T>,
    action: FieldValidationAction<T>
): FieldValidationState<T> => {
    switch (action.type) {
        case 'FIELD_CHANGED':
            return {
                ...state,
                validating: false,
                validated: false,
                error: undefined
            };
        case 'VALIDATING_FIELD':
            return {
                ...state,
                validating: true
            };
        case 'SERVER_SUCCESS':
            return {
                ...state,
                validating: false,
                validated: true,
                error: undefined,
                refData: action.payload?.fieldDetails as T
            };
        case 'SERVER_ERROR':
            return {
                ...state,
                validating: false,
                validated: true,
                error: action.payload.error
            };
        default:
            return state;
    }
};